export const useTabsWithPermissions = (tabs, userRoles) => {
  return tabs.filter(
    (tab) => userRoles.filter((role) => tab.roles.includes(role)).length > 0,
  );
};
